export default __webpack_public_path__ + "static/media/sv_SE.e87914c2.svg";